import React from 'react'
import { Button, Flex } from 'theme-ui'
import { experiments, useExperiment } from '~/hooks/utils/use-experiment'

export const AddToCartProductListQuantity = ({ setQuantity, quantity, sx }) => {
  const collectionsCardsTest = useExperiment(experiments.newProductCardLayout)

  return (
    <>
      <Flex
        sx={{
          alignItems: 'center',
          /*maxWidth: ['100%', collectionsCardsTest ? '100px' : '134px'],*/
          maxWidth: ['100%', '100px'],
          width: '100%',
          height: '40px',
          justifyContent: 'space-between',
          backgroundColor: 'transparent',
          borderRadius: '8px',
          /*px: collectionsCardsTest ? '8px' : '20px',*/
          px: '8px',
          border: 'solid 2px',
          borderColor: 'primary',
          color: 'primary',
          margin: 'auto',
          /*mr: collectionsCardsTest && ['0', '8px'],*/
          mr: ['0', '8px'],
          ...sx,
        }}
      >
        <Button
          sx={{
            backgroundColor: 'transparent',
            height: '24px',
            minHeight: '24px',
            width: '24px',
            minWidth: '24px',
            borderRadius: '50%',
            padding: '0px',
            border: 'solid 1px',
            borderColor: 'primary',
            lineHeight: '0px',
            color: 'inherit',
            paddingBottom: '.3125rem',
            ':hover': {
              borderColor: 'primary',
              color: 'primary',
            },
          }}
          onClick={() => setQuantity(prev => (prev > 1 ? prev - 1 : prev))}
        >
          -
        </Button>
        <span>{quantity}</span>
        <Button
          sx={{
            backgroundColor: 'transparent',
            height: '24px',
            minHeight: '24px',
            width: '24px',
            minWidth: '24px',
            borderRadius: '50%',
            padding: '0px',
            textAlign: 'center',
            border: 'solid 1px',
            borderColor: 'primary',
            color: 'inherit',
            paddingBottom: '.3125rem',
            ':hover': {
              borderColor: 'primary',
              color: 'primary',
            },
          }}
          onClick={() => setQuantity(prev => (prev > 4 ? prev : prev + 1))}
        >
          +
        </Button>
      </Flex>
    </>
  )
}
